import React from 'react';
import { Card, CardContent, Avatar } from '@mui/material';
import { ParticipantData } from '../../../../interface/Participant.interface';
import { ParticipantHandsSection } from './ParticipantHandsSection';
import { ParticipantActions } from './ParticipantActions';

interface ParticipantCardProps {
    participant: ParticipantData;
    index: number;
    totalShares: number;
    onCashIn: (participant: ParticipantData) => void;
    onWithdraw: (participant: ParticipantData) => void;
    onSettings: (participant: ParticipantData) => void;
}

export const ParticipantCard: React.FC<ParticipantCardProps> = ({
    participant,
    index,
    totalShares,
    onCashIn,
    onWithdraw,
    onSettings
}) => {
    const getInitials = (firstname: string, lastname: string) => {
        return `${firstname.charAt(0)}${lastname.charAt(0)}`.toUpperCase();
    };

    const isLate = !participant.upToDate;
    const statusText = isLate ? 'En retard' : 'À jour';
    const sharesText = `${participant.totalShare} part${participant.totalShare > 1 ? 's' : ''}`;

    return (
        <Card
            key={participant.uuid}
            className={`participant-card ${isLate ? 'late' : ''}`}
            style={{ animationDelay: `${index * 100}ms` }}
        >
            <CardContent className="participant-card-content">
                {/* Row 1: Avatar + Name + Actions */}
                <div className="participant-row-main">
                    <Avatar className={`participant-avatar ${isLate ? 'late' : ''}`}>
                        {getInitials(participant.firstname, participant.lastname)}
                    </Avatar>

                    <div className="participant-identity">
                        <span className="participant-name">
                            {participant.firstname} {participant.lastname}
                        </span>
                        <div className="participant-badges">
                            <span className="shares-badge">{sharesText}</span>
                            <span className={`status-badge ${isLate ? 'late' : 'ok'}`}>{statusText}</span>
                        </div>
                    </div>

                    <ParticipantActions
                        participant={participant}
                        onCashIn={onCashIn}
                        onWithdraw={onWithdraw}
                        onSettings={onSettings}
                    />
                </div>

                <ParticipantHandsSection participant={participant} />
            </CardContent>
        </Card>
    );
};
